import { render, staticRenderFns } from "./ConsumptionRecord.vue?vue&type=template&id=931ce4a4&scoped=true"
import script from "./ConsumptionRecord.vue?vue&type=script&lang=js"
export * from "./ConsumptionRecord.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionRecord.vue?vue&type=style&index=0&id=931ce4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931ce4a4",
  null
  
)

export default component.exports